import React from 'react';
import Select, { StylesConfig } from 'react-select';

import { CommonSelectProps } from './type';

import { isEmpty } from 'lodash';

import { COLOR, COLOR_CONFIG } from 'constants/color';

const CommonSelect: React.FC<CommonSelectProps> = ({
  value,
  options,
  onChange,
  onInputChange,
  noOptionsMessage,
  placeholder = '',
  isBorderInput,
  controlStyle,
  onFocus,
  disabled,
  getOptionLabel,
  formatOptionLabel,
  extraStyle,
  isSearchable = true,
  components,
}) => {
  const customStyle: StylesConfig = {
    container: (styles) => ({
      ...styles,
      width: '100%',
    }),
    input: (styles) => ({
      ...styles,
      caretColor: !isEmpty((value as { value: string })?.value) ? COLOR_CONFIG.white : 'black',
    }),
    control: (styles, { isFocused }) => ({
      ...styles,
      height: 44,
      borderRadius: isBorderInput ? 12 : styles.borderRadius,
      boxShadow: 'unset',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      borderColor: isFocused ? `${COLOR.primary['primary-6']}` : styles.borderColor,
      '&:hover': {
        borderColor: isFocused ? `${COLOR.primary['primary-6']}` : styles.borderColor,
      },
      ...controlStyle,
    }),
    option: (styles, { isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? `${COLOR.neutral['neutral-2']}` : `#ffffff`,
      color: isSelected ? `${COLOR.primary['primary-6']}` : '#1F1F1F',
      '&:hover': {
        backgroundColor: `${COLOR.neutral['neutral-2']}`,
        cursor: 'pointer',
      },
    }),
    noOptionsMessage: (styles) => ({
      ...styles,
      backgroundColor: '#ffffff',
    }),
    ...extraStyle,
  };

  return (
    <Select
      components={components}
      styles={customStyle}
      value={value}
      isDisabled={disabled}
      options={options}
      onChange={onChange}
      onInputChange={onInputChange}
      placeholder={placeholder}
      noOptionsMessage={noOptionsMessage || (() => 'No options')}
      onFocus={onFocus}
      getOptionLabel={getOptionLabel}
      formatOptionLabel={formatOptionLabel}
      isSearchable={isSearchable}
    />
  );
};

export default CommonSelect;
